// extracted by css-extract-rspack-plugin
export default {"bulkSelect":"whfOI","itemLink":"hbyJs","rowActions":"g7dHs"};